// eslint-disable-next-line import/no-cycle
import { fileThumbFormatter } from '../kdatatable/formatters';
import filePreviewModal from './modals/file-preview/file-preview-modal.component';
import filePreviewMultipleModal from './modals/file-preview-multiple/file-preview-multiple-modal.component';

/* globals Knitiv, Ktable */

/**
 * @param {import('@knitiv/api-client-javascript').KNode} kid
 * @param {import('angular').auto.IInjectorService} $injector
 * @returns {Promise<any>}
 */
export const viewFile = async (
	kid,
	$injector,
) => {
	/** @type {Knitiv.RootScope} */
	// @ts-ignore
	const $rootScope = $injector.get('$rootScope');
	const options = $rootScope.kds ? {
		...filePreviewMultipleModal({
			resolve: {
				kid: () => kid,
			},
		}),
	} : {
		...filePreviewModal({
			resolve: {
				kid: () => kid,
			},
		}),
	};

	const modalInstance = $injector.get('$uibModal').open(options);
	return modalInstance.result;
};

/**
 *
 * @param {*} contextMenuHandler
 * @param {import('angular').auto.IInjectorService} $injector
 * @param {*} getData
 * @param {Partial<import('tabulator-tables').ColumnDefinition>} [options]
 * @returns {import('tabulator-tables').ColumnDefinition}
 */
export const createFileThumb = (
	contextMenuHandler,
	$injector,
	getData = (/** @type {import('tabulator-tables').CellComponent} */ cell) => cell.getData(),
	options = {},
) => ({
	headerSort:  false,
	title:       '',
	hozAlign:    'center',
	formatter:   cell => {
		/** @type {Ktable.RowData} */
		const { root } = getData(cell);
		// @ts-ignore
		return fileThumbFormatter(root, null, null, $injector);
	},
	contextMenu: contextMenuHandler,
	cellClick:   async (event, cell) => {
		const { root } = getData(cell);
		const {
			kid,
			file,
		} = root;

		if (file === 1) {
			await viewFile(kid, $injector);
		}
	},
	...options,
	tooltip: '',
});

/**
 * @param {Partial<import('tabulator-tables').ColumnDefinition>} [options]
 * @returns {import('tabulator-tables').ColumnDefinition}
 */
export const rowNumberColumnDefinition = (options = {}) => ({
	headerSort: false,
	title:      '',
	hozAlign:   'center',
	formatter:  'rownum',
	...options,
	tooltip: '',
});

/**
 *
 * @param {Partial<import('tabulator-tables').ColumnDefinition>} [options]
 * @param {?import('angular').auto.IInjectorService} [$injector]
 * @returns {import('tabulator-tables').ColumnDefinition}
 */
// export const rowSelectionColumnDefinition = (options = {}) => ({
// 	title: '',
// 	formatter:      'rowSelection',
// 	titleFormatter: 'rowSelection',
// 	hozAlign:       'center',
// 	headerSort:     false,
// 	...options,
// 	tooltip: null,
// });
export const rowSelectionColumnDefinition = (options = {}, $injector = null) => ({
	title:     '',
	formatter: 'rowSelection',
	// @ts-ignore
	titleFormatter: 'rowSelectionK',
	hozAlign:       'center',
	headerSort:     false,
	// @ts-ignore
	titleFormatterParams: {
		rowRange: 'active',
		$injector,
	},
	...options,
	tooltip: '',
});

/**
 *
 * @param {Partial<import('tabulator-tables').ColumnDefinition>} [options]
 * @param {*} contextMenuHandler
 * @param {import('angular').translate.ITranslateService} $translate
 * @param {*} $scope
 * @param {import('angular').ICompileService} $compile
 * @param {*} getWorkflow
 * @returns {import('tabulator-tables').ColumnDefinition}
 */
export const createWorkflowCell = (
	options,
	// @ts-ignore
	contextMenuHandler,
	$translate,
	$scope,
	$compile,
	getWorkflow = (/** @type {import('tabulator-tables').CellComponent} */ cell) => cell.getValue(),
) => ({
	formatter: cell => {
		/** @type {import('@knitiv/api-client-javascript').QueryCellContent['wf']} */
		const wf = getWorkflow(cell);

		let element = '';
		const noWorkflows = '<i title="Aucun workflow disponible"></i>';
		// const noWorkflows = '<i title="Aucun workflow disponible" class="fa fa-exclamation-circle"></i>';

		if (wf && wf.length > 0) {
			if (wf.length === 1 && wf[0] !== undefined) {
				element = `
<wf-icon
tooltip-append-to-body="true"
uib-tooltip="${wf[0].title ?? ''}"
color="'${wf[0].color}'"
/>`;
			}

			else if (wf.length > 1) {
				element = `
<wf-icon tooltip-append-to-body="true"
uib-tooltip="${$translate.instant('common.multiple')}"
multiple="multiple"
/>`;
			}
			else {
				return noWorkflows;
			}

			return $compile(element)($scope)[0];
		}

		return noWorkflows;
	},
	hozAlign:  'center',
	sorter:    'exists',
	title:     '',
	...options,
	tooltip: '',
});
